var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 12.875L14.4938 18.2562C14.2159 18.5352 13.8857 18.7565 13.5221 18.9075C13.1585 19.0585 12.7687 19.1363 12.375 19.1363C11.9813 19.1363 11.5915 19.0585 11.2279 18.9075C10.8643 18.7565 10.5341 18.5352 10.2563 18.2562L6.24377 14.2438C5.96485 13.9659 5.74353 13.6357 5.59252 13.2721C5.44151 12.9085 5.36377 12.5187 5.36377 12.125C5.36377 11.7313 5.44151 11.3415 5.59252 10.9779C5.74353 10.6143 5.96485 10.2841 6.24377 10.0063L11.625 4.625",
    stroke: "#FF136D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.25L3 21.5",
    stroke: "#FF136D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.5L17.25 2.75",
    stroke: "#FF136D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 7.25L18 11",
    stroke: "#FF136D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14L10.5 3.5",
    stroke: "#FF136D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIcon);
export default __webpack_public_path__ + "static/media/plug-icon.24f5fb6f4f69f51ab3c2112f4cd77ecb.svg";
export { ForwardRef as ReactComponent };